import React, { useState } from "react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { SearchBox } from "@fluentui/react/lib/SearchBox";
import { Link } from "@fluentui/react/lib/Link";
import {
  DetailsList,
  DetailsListLayoutMode,
} from "@fluentui/react/lib/DetailsList";
import moment from "moment";
import CONSTANT from "../../constant";
import Header from "../../component/common/Header";
import UploadForm from "../../component/knowledgeManagement/uploadForm";

import {
  addFile,
  searchFile,
  deleteFile,
  getKMFileList
  
} from "../../actions/KnowledgeManagement";
 
import { getStorage } from "../../utils";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { FontIcon } from "@fluentui/react/lib/Icon";
import { SelectionMode } from "@fluentui/react/lib/Selection";

function getColumns(isAdmin, onDeleteClick) {
  const columns = [
    {
      key: "title",
      name: "Title",
      fieldName: "title",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "description",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "fileName",
      name: "File Name",
      fieldName: "fileName",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
     
    {
      key: "uploadedBy",
      name: "Uploaded By",
      fieldName: "createdBy",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
     
    {
      key: "uploadedOn",
      name: "Uploaded On",
      fieldName: "createdOn",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
     
  ];
   
  if (isAdmin) {

    columns.push({
      key: "delete",
      name: "",
      fieldName: "delete",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      onRender: (item) => {
        return (
          <DefaultButton onClick={() => onDeleteClick(item) }>
            <FontIcon aria-label="delete" iconName="delete" />
          </DefaultButton>
        );
      },
    });
  }
  return columns;
}

function KnowledgeManagement() {
   
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [showUploadLoader, setShowUploadLoader] = useState(false);

   const [uploadedFileList , setuploadedFileList] = useState(false)
   const [fileList,setFileList] = useState([])
   
  const permissions = getStorage(CONSTANT.cookie.permissions);
   
  const isAdmin = permissions.some(
    (item) => item === CONSTANT.static.permissions.userAdminAccess
  );

  const columns = getColumns(isAdmin, onDeleteClick);
   
  async function onSubmit(data) {
    setuploadedFileList(false)
    setShowUploadLoader(true);
    await addFile(data);
    setShowFileUpload(false);
    setShowUploadLoader(false);
  
   }

  function onEnteringSearch(e) {
   
    const value = e && e.target && e.target.value;
    setSearchText(value);
  
   }

  async function onSearchClick() {
     
    setuploadedFileList(false);
    try {
      const { result } = await searchFile(searchText);
      setSearchData(result);
    } catch (e) {
      console.error(e, "error");
    }
    setShowSearchLoader(false);
  }

  async function onDeleteClick(item) {
     
    const response = await deleteFile(item.id);
    const { result } = await searchFile(searchText);
    setSearchData(result);     
    getKMFileList().then((res) => {
      setFileList(res.result)
    });
     
  }




  function _renderItemColumn(item, index, column) {
    const fieldContent = item[column.fieldName];
     
    switch (column.key) {
      case "fileName":
        const url =   
          `${process.env.REACT_APP_BASE_URL}knowledge/${fieldContent}`.replace(
            "v1/",
            ""
          );
        return (
          <Link target="_blank" href={url}>
            {fieldContent}
          </Link>
        );

      case "uploadedOn":
        return <span>{moment(fieldContent).format("DD-MM-YYYY HH:MM")}</span>;

      default:
        return <span>{fieldContent}</span>;
    }
  }



   function getUploadedFileListData (){
    setuploadedFileList(true)
    setSearchData([])
     
      getKMFileList().then((res) => {
         setFileList(res.result)
       });
  
      }

  return (
    <div className="container-fluid">
      <div className="row">
        {/* <div className="col-md-2 px-0">
          <Header />
        </div> */}
        <div className="col-md-12 min-h-full">
          <div className="card homedob p-4 mb-4">
          <div className="row my-3 h-6">
            <div className="col-md-8">
              <h1 className="page-title">Knowledge Management</h1>
            </div>
          </div>
          
             {
              !isAdmin?
              <div className="row my-3 mb-4 col-md-8 h-6">
              <div className="row ml-2 col-md-8 h-6">
              <PrimaryButton onClick={() =>getUploadedFileListData()  
              }>
                Document List
              </PrimaryButton>
            </div>
            </div>:""
             }          
     
      
        <div className="w-full"></div>
          
          {permissions.some(
            (permissionCode) =>
              permissionCode === CONSTANT.static.permissions.kmsUploadAccess
          ) ? (
            <React.Fragment>
              <div className="row">
                <div className="col-md-6">
                <PrimaryButton onClick={() => setShowFileUpload(true)} className="d-block w-100"
                  size={'large'}>
                  Upload Document
                </PrimaryButton>
                </div>
                 <div className="col-md-6 d-block w-100 p-0">
                  {
                  isAdmin? 
                  <div className="col-md-12">
                  <PrimaryButton onClick={() =>getUploadedFileListData()} className="d-block w-100" size={'large'}>
                    Document List
                  </PrimaryButton>
                </div>
                :""
                 }
                 </div>
              </div>
              <div className="w-full"></div>
            </React.Fragment>
          ) : null}

          <div className="row h-5/6 p-3">
            <div className="h-16 p-3 w-full flex justify-between bg-white rounded-sm shadow-sm">
              
             <SearchBox
                placeholder="Search Documents"
                onChange={onEnteringSearch}
                className="mr-2 w-5/6"
              />
               
              <PrimaryButton className="w-1/6" onClick={onSearchClick}>
                Search
              </PrimaryButton>
            </div>
            <div className="h-5/6 w-full">
            
            {uploadedFileList?
               
              <DetailsList
              items={fileList}
              columns={columns}
              getKey={(item) => `${item.id}`}
              setKey="none"
              layoutMode={ DetailsListLayoutMode.justified }
              isHeaderVisible={true}
              onRenderItemColumn={_renderItemColumn}
              selectionMode={SelectionMode.none}
            /> 
           
             : "" 
             
             }
   
             
              {searchData.length ? (
                showSearchLoader ? (
                  <p>Loading...</p>
                ) : (
                  <DetailsList
                    items={searchData}
                    columns={columns}
                    getKey={(item) => `${item.id}`}
                    setKey="none"
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                    onRenderItemColumn={_renderItemColumn}
                    selectionMode={SelectionMode.none}
                  />
                )
              ) : (
                // <p style={{ marginTop: "10px", textAlign: "center" }}>
                //   Enter a term to search 
                // </p>
                 ""
              )}
  
            </div>
          </div>
          </div>
        </div>
      </div>
       
      <UploadForm
        showLoader={showUploadLoader}
        onSubmit={onSubmit}
        isOpen={showFileUpload}
        onDismiss={() => setShowFileUpload(false)}
      />

    </div>
  );
}

export default KnowledgeManagement;
